import * as React from "react";
import { SVGProps, memo } from "react";

const SvgAlert = (props: SVGProps<SVGSVGElement>) => (
  <svg width={26} height={26} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 7.518 7.518 3.25h10.964l4.268 4.268v10.964l-4.268 4.268H7.518L3.25 18.482V7.518ZM7.414.75a2.25 2.25 0 0 0-1.59.659L1.408 5.823A2.25 2.25 0 0 0 .75 7.414v11.172c0 .597.237 1.169.659 1.59l4.414 4.415a2.25 2.25 0 0 0 1.591.659h11.172a2.25 2.25 0 0 0 1.59-.659l4.415-4.414a2.25 2.25 0 0 0 .659-1.591V7.414a2.25 2.25 0 0 0-.659-1.59l-4.414-4.415A2.25 2.25 0 0 0 18.586.75H7.414ZM13 6.5c.69 0 1.25.56 1.25 1.25v5.5a1.25 1.25 0 1 1-2.5 0v-5.5c0-.69.56-1.25 1.25-1.25Zm1.5 11.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      fill="#E42F0D"
    />
  </svg>
);

const Memo = memo(SvgAlert);

export default Memo;
